import router from '../../router'
import {
  EXIST_WILL_MUST_DRAFT, EXIST_WILL_MUST_DRAFT_SUCCESS, EXIST_WILL_MUST_DRAFT_FAILURE,
  GET_WILL_MUST_DRAFT, GET_WILL_MUST_DRAFT_SUCCESS, GET_WILL_MUST_DRAFT_FAILURE,
  GET_WILL_MUST, GET_WILL_MUST_SUCCESS, GET_WILL_MUST_FAILURE,
  SAVE_WILL_MUST_DRAFT, SAVE_WILL_MUST_DRAFT_SUCCESS, SAVE_WILL_MUST_DRAFT_FAILURE,
  SAVE_WILL_MUST, SAVE_WILL_MUST_SUCCESS, SAVE_WILL_MUST_FAILURE,
  GET_ALL_WILL_MUST, GET_ALL_WILL_MUST_SUCCESS, GET_ALL_WILL_MUST_FAILURE
} from './mutation-types'

export default {
  state: {
    willMustDate: null,
    willData: null,
    mustData: null,
    reflectData: null,
    evaluationData: null,
    willDraftData: null,
    mustDraftData: null,
    reflectDraftData: null,
    evaluationDraftData: null,
    willMustList: null,
    willDetail: null,
    mustDetail: null,
    reflectDetail: null,
    evaluationDetail: null
  },
  getters: {
    willMustDate: state => {
      return state.willMustDate
    },
    willData: state => {
      return state.willData
    },
    mustData: state => {
      return state.mustData
    },
    reflectData: state => {
      return state.reflectData
    },
    evaluationData: state => {
      return state.evaluationData
    },
    willDraftData: state => {
      return state.willDraftData
    },
    mustDraftData: state => {
      return state.mustDraftData
    },
    reflectDraftData: state => {
      return state.reflectDraftData
    },
    evaluationDraftData: state => {
      return state.evaluationDraftData
    },
    willMustList: state => {
      return state.willMustList
    },
    willDetail: state => {
      return state.willDetail
    },
    mustDetail: state => {
      return state.mustDetail
    },
    reflectDetail: state => {
      return state.reflectDetail
    },
    evaluationDetail: state => {
      return state.evaluationDetail
    }
  },
  actions: {
    [EXIST_WILL_MUST_DRAFT] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/asovi/will_musts/', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(EXIST_WILL_MUST_DRAFT_FAILURE, res.data)
          } else {
            commit(EXIST_WILL_MUST_DRAFT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_ALL_WILL_MUST] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/asovi/will_musts/get_all', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_ALL_WILL_MUST_FAILURE, res.data)
          } else {
            commit(GET_ALL_WILL_MUST_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_WILL_MUST_DRAFT] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/asovi/will_musts/get_draft', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_WILL_MUST_DRAFT_FAILURE, res.data)
          } else {
            commit(GET_WILL_MUST_DRAFT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [GET_WILL_MUST] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/asovi/will_musts/get_will_must', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_WILL_MUST_FAILURE, res.data)
          } else {
            commit(GET_WILL_MUST_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SAVE_WILL_MUST_DRAFT] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiPatch', {url: '/asovi/will_musts/save_draft', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SAVE_WILL_MUST_DRAFT_FAILURE, res.data)
          } else {
            commit(SAVE_WILL_MUST_DRAFT_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [SAVE_WILL_MUST] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiPatch', {url: '/asovi/will_musts/save_will_must', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(SAVE_WILL_MUST_FAILURE, res.data)
          } else {
            commit(SAVE_WILL_MUST_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [EXIST_WILL_MUST_DRAFT_FAILURE] (state, params) {
      console.log('EXIST_WILL_MUST_DRAFT_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [EXIST_WILL_MUST_DRAFT_SUCCESS] (state, params) {
      console.log('EXIST_WILL_MUST_DRAFT_SUCCESS')
      state.willMustDate = params.data['will_must_date']
      if (params.callback) {
        params.callback()
      }
    },
    [GET_WILL_MUST_DRAFT_FAILURE] (state, params) {
      console.log('GET_WILL_MUST_DRAFT_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_WILL_MUST_DRAFT_SUCCESS] (state, params) {
      console.log('GET_WILL_MUST_DRAFT_SUCCESS')
      if (Object.keys(params.data['draft']).length === 0) {
        router.push('/will_must_sent')
      } else {
        state.willMustDate = params.data['will_must']['will_must_date']
        state.willData = params.data['will_must']['will_content']
        state.mustData = params.data['will_must']['must_content']
        state.reflectData = params.data['will_must']['reflect_content']
        state.evaluationData = params.data['will_must']['evaluation']
        state.willDraftData = params.data['draft']['will_content']
        state.mustDraftData = params.data['draft']['must_content']
        state.reflectDraftData = params.data['draft']['reflect_content']
        state.evaluationDraftData = params.data['draft']['evaluation']
        if (params.callback) {
          params.callback()
        }
      }
    },
    [GET_WILL_MUST_SUCCESS] (state, params) {
      console.log('GET_WILL_MUST_SUCCESS')
      state.willDetail = params.data['will_content']
      state.mustDetail = params.data['must_content']
      state.reflectDetail = params.data['reflect_content']
      state.evaluationDetail = params.data['evaluation']
      if (params.callback) {
        params.callback()
      }
    },
    [SAVE_WILL_MUST_FAILURE] (state, params) {
      console.log('SAVE_WILL_MUST_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [SAVE_WILL_MUST_DRAFT_FAILURE] (state, params) {
      console.log('SAVE_WILL_MUST_DRAFT_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [SAVE_WILL_MUST_DRAFT_SUCCESS] (state, params) {
      console.log('SAVE_WILL_MUST_DRAFT_SUCCESS')
      if (params.callback) {
        params.callback(params.data.target)
      }
    },
    [SAVE_WILL_MUST_FAILURE] (state, params) {
      console.log('SAVE_WILL_MUST_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [SAVE_WILL_MUST_SUCCESS] (state, params) {
      console.log('SAVE_WILL_MUST_SUCCESS')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_ALL_WILL_MUST_FAILURE] (state, params) {
      console.log('GET_ALL_WILL_MUST_FAILURE')
      if (params.callback) {
        params.callback()
      }
    },
    [GET_ALL_WILL_MUST_SUCCESS] (state, params) {
      console.log('GET_ALL_WILL_MUST_SUCCESS')
      if (params.data.length > 0) {
        state.willMustList = params.data
      }
      if (params.callback) {
        params.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/will-must.js